import { render, staticRenderFns } from "./total-messages.vue?vue&type=template&id=518be994&scoped=true&"
import script from "./total-messages.vue?vue&type=script&lang=js&"
export * from "./total-messages.vue?vue&type=script&lang=js&"
import style0 from "./total-messages.vue?vue&type=style&index=0&id=518be994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518be994",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
